export enum EGeneralMessageLink {
  button = 'button',
  url = 'url',
}

export type TGeneralMessageLink = {
  type: EGeneralMessageLink;
  label: string;
  url: string;
  guard?: string;
};

export type TPropsPassedMessageBox = {
  title: string[];
  description: string[];
  links: TGeneralMessageLink[];
};

export interface IPropsPassedMessage {
  box: TPropsPassedMessageBox;
}
